import React from 'react';
import AdminTeacherCard from './AdminTeacherCard'
import AdminTeacherModal from './AdminTeacherModal/AdminTeacherModal'
import Axios from 'axios';
import AddTeacherModal from './AddTeacherModal/AddTeacherModal';
import {baseUrl} from './assets/Animations'
import SoloStudentModal from './SoloStudentModal/SoloStudentModal';
import NewLoadingScreen from './NewLoadingScreen/NewLoadingScreen';
import loadingping from './img/loadingpin.svg'
import ViewTimesheet from './CreateTimesheet/ViewTimesheet/ViewTimesheet'
import StudentModal2022 from './StudentModal2022/StudentModal2022';

const AdminDashboard = (props) => {

    const [teachers, setTeachers] = React.useState([])
    const [filteredTeachers, setFilteredTeachers] = React.useState([])
    const [teachersToDisplay, setTeachersToDisplay] = React.useState([])
    const [teacherModal, setTeacherModal] = React.useState(false)
    const [wholeAvail, setWholeAvail] = React.useState([])
    const [allStudents, setAllStudents] = React.useState([])
    const [nameQuery, setNameQuery] = React.useState('')
    const [instQuery, setInstQuery] = React.useState('')
    const [schoolQuery, setSchoolQuery] = React.useState('')
    const [statusQuery, setStatusQuery] = React.useState('')
    const [dateQuery, setDateQuery] = React.useState('Everyday')
    const [fullQuery, setFullQuery] = React.useState('Available')
    const [background, setBackground] = React.useState('background-1.jpg')
    const [addTeacherModal, setAddTeacherModal] = React.useState(false)
    const [lineView, setLineView] = React.useState(false)
    const [studentModal, setStudentModal] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [loadingSVG, setLoadingSVG] = React.useState(false)
    const [openTimesheet, setOpenTimesheet] = React.useState(false)
    const [timesheets, setTimesheets] = React.useState([])


    React.useEffect(() => {
        setLoadingSVG(true)
        getTeachersAndStudents()
        getTimesheets()
    }, [])

    React.useEffect(() => {
        filterTeachers()
    }, [teachers])

    React.useEffect(() => {
        console.log(timesheets)
    },[timesheets])

    React.useEffect(() => {
        if(teacherModal && !props.studentModal2022) {
            setTimeout(() => {
                props.getNotesAboutModal(teacherModal.TeacherID, 'teacherId', teacherModal.Name)
            }, 300)
        }
    }, [teacherModal, props.studentModal2022])

    React.useEffect(() => {
        calculateAndSortByNumberOfStudents()
        if(teacherModal !== {}) {
            updateOpenTeacherModal()
        }
    }, [allStudents, filteredTeachers])

    React.useEffect(() => {
        filterTeachers()
        changeBackgroundImageBySchool()
    }, [nameQuery, instQuery, schoolQuery, statusQuery, dateQuery, fullQuery])

    const getTeachersAndStudents = () => {
        let myToken = localStorage.getItem('token')
        let myHeader = {
            headers: { Authorization: `Bearer ${myToken}` }
        }
        Axios.get(`${baseUrl}/school-management`, myHeader)
        .then(studentResponse => {
            getTeachers(studentResponse.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const getTimesheets = () => {
        Axios.get(`${baseUrl}/getalltimesheetsendpoint`)
        .then(response => {
            setTimesheets(response.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const getTeachers = (theStudents) => {
        let myToken = localStorage.getItem('token')
        let myHeader = {
            headers: { Authorization: `Bearer ${myToken}` }
        }
        Axios.get(`${baseUrl}/initialadminrequest`, myHeader)
        .then(response => {
            createTheNewStudentListInEachTeacherAndSetTeachers(response.data)
            setAllStudents(theStudents)
            setLoadingSVG(false)
        })
        .catch(function (error) {
          console.log(error)
        })
    }

    const createTheNewStudentListInEachTeacherAndSetTeachers = (list) => {
        for(let i = 0; i < list.length; i++) {
            list[i].newStudentList = []
        }
        setTeachers(list)
    }

    const changeBackgroundImageBySchool = () => {
        if(schoolQuery === 'mma') {
            setBackground('MMA.jpg')
        } else if (schoolQuery === 'lsma') {
            setBackground('LMA.jpg')
        } else if (schoolQuery === 'tma') {
            setBackground('TMA.jpg')
        } else if (schoolQuery === 'glma') {
            setBackground('GLMA.jpg')
        } else {
            setBackground('background-1.jpg')            
        }
    }

    const calculateAndSortByNumberOfStudents = () => {
        //ADD NEW CATAGORY TO THE TEACHERS
        let teachersWithStudents = filteredTeachers
        for(let i = 0; i < teachersWithStudents.length; i++) {
            teachersWithStudents[i].newStudentList = []
        }
        //CHECK ALL STUDENTS TO SEE WHO THEIR TEACHER IS
        for(let i = 0; i < allStudents.length; i++) {
           if(allStudents[i].familyStatus === 'Active') {
               for(let j = 0; j < allStudents[i].students.length; j++) {
                   if(allStudents[i].students[j].studentStatus === 'Active') {
                       let teachersId = allStudents[i].students[j].teachersId
                        for(let k = 0; k < teachersWithStudents.length; k++) {
                            if(teachersWithStudents[k].TeacherID === teachersId) {
                                teachersWithStudents[k].newStudentList.push({
                                    familyId: allStudents[i].familyId,
                                    studentId: allStudents[i].students[j].studentId,
                                    firstName: allStudents[i].students[j].studentName,
                                    lastName: allStudents[i].familyName
                                })
                            }
                        }
                   }
               }
           } 
        }
        setTeachersToDisplay([...sortByStudent(teachersWithStudents)])
    }

    const sortByStudent = (list) => {
        let sortedFinalList = list.sort((a, b) => {
            return b.newStudentList.length - a.newStudentList.length;
        })
        return sortedFinalList
    }

    const filterTeachers = () => {
        let masterList = teachers
        masterList = masterList.filter(teacher => {
            const teachName = teacher.Name.toString().toLocaleLowerCase();
            const nameFilter = nameQuery.toString().toLocaleLowerCase();
            return teachName.includes(nameFilter)
          })
          if(instQuery !== ''){
            masterList = masterList.filter(teacher => {
                // const instName = teacher.Instrument.toString().toLocaleLowerCase();
                const instFilter = instQuery.toString().toLocaleLowerCase()
                for(let i = 0; i < teacher.InstrumentList.length; i++) {
                    const instInListName = teacher.InstrumentList[i].name.toLocaleLowerCase()
                    if(instInListName.includes(instFilter)) {
                        return instInListName.includes(instFilter)
                    }
                }
                //return instName.includes(instFilter)
              })
          }
       masterList = masterList.filter(teacher => {
            const schoolName = teacher.School
            return schoolName.includes(schoolQuery)
        })
        masterList = masterList.filter(teacher => {
            if(statusQuery === "Active") {
                if(teacher.newStudentList.length > 0) {
                    return teacher
                }
            } else if (statusQuery === 'Waiting') {
                if (teacher.newStudentList.length === 0) {
                    return teacher
                } 
            } else if (statusQuery === 'leaving') {
                if (teacher.Status === 'leaving') {
                    return teacher
                } 
            } else if (statusQuery === 'goon') {
                if (teacher.Status === 'goon') {
                    return teacher
                } 
            } else {
                return teacher
            }
        })
        if(dateQuery !== 'Everyday') {
            let stagingList = []
            masterList.forEach(teacher => {
                if(teacher.AvailabilityDetails[dateQuery].length > 0) {
                    stagingList.push(teacher)
                }
            });
            masterList = stagingList
        }
        masterList = masterList.filter(teacher => {
            if(fullQuery === 'Available') {
                if (teacher.WantsMoreStudents === true) {
                    return teacher
                }
            } else if (fullQuery === 'Full') {
                if (teacher.WantsMoreStudents === false) {
                    return teacher
                }
            } else if (fullQuery === 'All Availabilities') {
                return teacher
            }
        })
        setFilteredTeachers(masterList)
    }

    const openNewTeacher = () => {
            setAddTeacherModal(prevState => !prevState)
    }
    const closeNewTeacherModal = (teacherInfo) => {
        let addATeacher = teachers
        addATeacher.push(teacherInfo)
        setTeachers([...addATeacher])
        setAddTeacherModal(false)
    }

    const removeDeletedTeacher = (TeacherID) => {
        for(let i = 0; i < teachers.length; i++) {
            if(teachers[i].TeacherID === TeacherID) {
                teachers.splice(i, 1);
                setTeachers([...teachers])
            }
        }
    }

    const massCheck = (isChecked) => {
        let theBoxes = document.getElementsByClassName('student-checkbox')
        if(isChecked) {
            for(let i = 0; i < theBoxes.length; i++){
                theBoxes[i].checked = true
            }
        } else {
            for(let i = 0; i < theBoxes.length; i++){
                theBoxes[i].checked = false
            }
        }
    }

    const copyAttempt = () => {
        let theList = ''
        let theBoxes = document.getElementsByClassName('student-checkbox')
        for(let i = 0; i < theBoxes.length; i++) {
            if(theBoxes[i].checked === true) {
                theList = theList + ' ' + theBoxes[i].value + ';'
            }
        }
        navigator.clipboard.writeText(theList)
        setTimeout(function(){
            alert("Emails have been copied to you clipboard")
        }, 0)
    }
    const openStudentModal = async (familyId) => {
        setLoading('Getting Student')
        Axios.get(`${baseUrl}/school-management/${familyId}`)
        .then((res) => {
            setStudentModal(res.data)
            setLoading(false)
        })
        .catch((err) => {
            console.log(err)
        })
    }
    const updateOpenTeacherModal = () => {
        let updatedTeacherModal = teacherModal
        for(let i = 0; i < teachers.length; i++) {
            if(teacherModal.TeacherID === teachers[i].TeacherID) {
                updatedTeacherModal.newStudentList = teachers[i].newStudentList
                setTeacherModal(updatedTeacherModal)
            }
        }
    }
    const closeStudentModal = (msg, family) => {
        let updatedStudents = allStudents
        for(let i = 0; i < updatedStudents.length; i++) {
            if(updatedStudents[i].familyId === family.familyId) {
                updatedStudents[i] = family
            }
        }
        setAllStudents([...updatedStudents])
        setStudentModal(false)
    }
    const closeTeacherModal = (teacherData) => {
        //setModal(false)
        setTeacherModal(false)
        //props.setShowNotes(false)
        props.closeSideNotesWithAnimation()
        let updatedTeacherList = teachers
        let updatedFilteredTeacherList = filteredTeachers
        for(let i = 0; i < updatedTeacherList.length; i++) {
            if(updatedTeacherList[i].TeacherID === teacherData.TeacherID) {
                updatedTeacherList[i] = teacherData
                setTeachers([...updatedTeacherList])
            }
        }
        for(let i = 0; i < updatedFilteredTeacherList.length; i++) {
            if(updatedFilteredTeacherList[i].TeacherID === teacherData.TeacherID) {
                updatedFilteredTeacherList[i] = teacherData
                setFilteredTeachers([...updatedFilteredTeacherList])
            }
        }
    }

    return(
        <div className="admin-dashboard" style={{backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' + background + ')'}}>
            {loading && <NewLoadingScreen message={loading} />}
            {teacherModal && <AdminTeacherModal openStudentModal={openStudentModal} closeModal={closeTeacherModal} wholeAvail={wholeAvail} teacher={teacherModal} removeDeletedTeacher={removeDeletedTeacher} setOpenTimesheet={setOpenTimesheet} getFamilyData={props.getFamilyData} />}
            <AddTeacherModal open={addTeacherModal} closeModal={closeNewTeacherModal} setAddTeacherModal={setAddTeacherModal} />
            {openTimesheet && <ViewTimesheet setOpenTimesheet={setOpenTimesheet} openTimesheet={openTimesheet} />}
            <div className="admin-db-title">Teacher Database</div>
            <div className="add-search-wrapper">
                <div className="searchbars-wrapper">
                    <div className="add-student-btn" onClick={() => setAddTeacherModal(true)}>+ New Teacher</div>
                    <input className="admin-search login-input" id="admin-portal-teacher-search" value={nameQuery} onChange={(e) => setNameQuery(e.target.value)} placeholder="Search by Name"/>
                    <input className="admin-search login-input" id="admin-portal-inst-search" value={instQuery} onChange={(e) => setInstQuery(e.target.value)} placeholder="Search by Instrument"/>
                </div>
            </div>
            <div className="filters-wrapper teacher-filters">
                    <select className="student-db-filter" id="teacher-filter" style={dateQuery === 'Everyday' ? {backgroundColor: "#8EAAAF"} : {backgroundColor: "rgb(240, 162, 16)"}} placeholder="Search by Availability" value={dateQuery} onChange={(e) => setDateQuery(e.target.value)}>
                        <option default value="Everyday">All Days</option>
                        <option value="Monday">Mondays</option>
                        <option value="Tuesday">Tuesdays</option>
                        <option value="Wednesday">Wednesdays</option>
                        <option value="Thursday">Thursdays</option>
                        <option value="Friday">Fridays</option>
                        <option value="Saturday">Saturdays</option>
                        <option value="Sunday">Sundays</option>
                    </select>
                    <select className="student-db-filter" id="teacher-full-filter" style={fullQuery === 'All Availabilities' ? {backgroundColor: "#8EAAAF"} : {backgroundColor: "rgb(240, 162, 16)"}} value={fullQuery} onChange={(e) => setFullQuery(e.target.value)}>
                        <option default value="Available">Available</option>
                        <option value="Full">Full</option>
                        <option value="All Availabilities">All Availabilities</option>
                    </select>
                    <select className="student-db-filter" id="school-selector" style={schoolQuery === '' ? {backgroundColor: "#8EAAAF"} : {backgroundColor: "rgb(240, 162, 16)"}} onChange={(e) => setSchoolQuery(e.target.value)} >
                        <option value="" default>All Schools</option>
                        <option value="mma">Mountainside</option>
                        <option value="lsma">Lakeside</option>
                        <option value="tma">Treeside</option>
                        <option value="mor">Morningside</option>
                        <option value="psma">Parkside</option>
                    </select>
                    <select className="student-db-filter last-filter" id="status-filter" value={statusQuery} style={statusQuery === '' ? {backgroundColor: "#8EAAAF"} : {backgroundColor: "rgb(240, 162, 16)"}} onChange={(e) => setStatusQuery(e.target.value)}>
                        <option value="" default>All Status</option>
                        <option value="Active" default>Active</option>
                        <option value="leaving" default>Leaving</option>
                        <option value="goon" default>Goon</option>
                        <option value="Waiting">Waiting</option>
                    </select>
                    <div className="toggle-view" onClick={() => setLineView(prevState => !prevState)}>
                    {lineView && <svg className="switch-svg" viewBox="0 0 511.999 511.999">
                        <g>
                        	<g>
                        		<path fill="#8EAAAF" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                        			S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                        			c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                        	</g>
                        </g>
                    </svg>}
                    {!lineView && <svg className="switch-svg" viewBox="0 0 512 512">
                        <g>
                        	<g>
                        		<path fill="#8EAAAF" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                        			S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                        			c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                        	</g>
                        </g>
                    </svg>}
                    </div>
            </div>
            <div className="admin-dashboard-box student-db-box">
                {!lineView && <div className="admin-teacher-card-wrapper">
                    {loadingSVG && <img className="loading-ping" src={loadingping} />}
                    {filteredTeachers.map((teacher) => <AdminTeacherCard key={teacher.TeacherID} id={`teacher-card-${teacher.TeacherID}`} teacherStatus={teacher.Status} openModal={(teacher) => setTeacherModal(teacher)} teacher={teacher} timesheets={timesheets}/>)}
                </div>}
                {lineView && <div className="the-table-wrapper">
                <div className="student-db-btn-wrapper">
            <div className="add-email-btn" onClick={() => copyAttempt()}>COPY EMAILS</div>
            </div>
                <table className="student-table">
                    <thead>
                        <tr>
                            <th><input onClick={(e) => massCheck(e.target.checked)} type="checkbox" /></th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Students</th>
                            <th>School</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                        {
                            teachersToDisplay.length > 0 ?
                                <tbody>
                                    {
                                        teachersToDisplay.map(teacher => (
                                            <tr key={teacher.TeacherID} className="each-row">
                                                <td><input className={"student-checkbox"} type="checkbox" value={teacher.Email}/></td>
                                                <td onClick={() => setTeacherModal(teacher)}>{teacher.Name}</td>
                                                <td onClick={() => setTeacherModal(teacher)}>{teacher.Email}</td>
                                                <td onClick={() => setTeacherModal(teacher)}>{teacher.PhoneNumber}</td>
                                                <td onClick={() => setTeacherModal(teacher)}>{teacher.newStudentList.length}</td>
                                                <td onClick={() => setTeacherModal(teacher)}>{teacher.School}</td>
                                                <td onClick={() => setTeacherModal(teacher)}>{teacher.newStudentList.length > 0 ? 'Active' : 'Waiting'}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            :
                                <tbody>
                                    <div className="admin-tasks-loading-text">Getting teachers...</div>
                                </tbody>
                        }
                </table>
            </div>}
            </div>
        </div>
    )
}

export default AdminDashboard